import {
  ADD_BOOKING,
  ADD_BOOKING_FAILED,
  GET_BOOKING,
  GET_BOOKING_FAILED,
  GET_BOOKING_SUCCESS,
  GET_BOOKING_TYPE,
  GET_BOOKING_TYPE_FAILED,
  GET_BOOKING_TYPE_SUCCESS,
  RESET_BOOKING,
} from "./actionTypes"

export const getBookingType = params => ({
  type: GET_BOOKING_TYPE,
  payload: { params },
})

export const getBookingTypeSuccess = response => ({
  type: GET_BOOKING_TYPE_SUCCESS,
  payload: response,
})

export const getBookingTypeFailed = error => ({
  type: GET_BOOKING_TYPE_FAILED,
  payload: error,
})

export const addBooking = params => ({
  type: ADD_BOOKING,
  payload: params,
})

export const addBookingFaied = error => ({
  type: ADD_BOOKING_FAILED,
  payload: error,
})

export const getBooking = params => ({
  type: GET_BOOKING,
  payload: { params },
})

export const getBookingSuccess = response => ({
  type: GET_BOOKING_SUCCESS,
  payload: response,
})

export const getBookingFailed = error => ({
  type: GET_BOOKING_FAILED,
  payload: error,
})

export const resetBooking = () => ({
  type: RESET_BOOKING,
  payload: {},
})
